var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.59688 12.6769L2.5 5H12.5L11.4031 12.6769C11.3605 12.9747 11.212 13.2472 10.9846 13.4444C10.7573 13.6415 10.4665 13.75 10.1656 13.75H4.83438C4.53348 13.75 4.24268 13.6415 4.01536 13.4444C3.78804 13.2472 3.63945 12.9747 3.59688 12.6769ZM13.125 2.5H10V1.875C10 1.70924 9.93415 1.55027 9.81694 1.43306C9.69973 1.31585 9.54076 1.25 9.375 1.25H5.625C5.45924 1.25 5.30027 1.31585 5.18306 1.43306C5.06585 1.55027 5 1.70924 5 1.875V2.5H1.875C1.70924 2.5 1.55027 2.56585 1.43306 2.68306C1.31585 2.80027 1.25 2.95924 1.25 3.125C1.25 3.29076 1.31585 3.44973 1.43306 3.56694C1.55027 3.68415 1.70924 3.75 1.875 3.75H13.125C13.2908 3.75 13.4497 3.68415 13.5669 3.56694C13.6842 3.44973 13.75 3.29076 13.75 3.125C13.75 2.95924 13.6842 2.80027 13.5669 2.68306C13.4497 2.56585 13.2908 2.5 13.125 2.5Z",
    fill: "#FF5656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete8);
export default __webpack_public_path__ + "static/media/delete 8.3dfcd7888434637534547ba474c8130c.svg";
export { ForwardRef as ReactComponent };